export default function getClientId(state) {
  if (state.loginForm && state.loginForm.clientId) {
    return state.loginForm.clientId;
  }
  return '';
}